import React, { Component } from 'react'
import ReactSwipe from 'react-swipe'
import CarouselControls from './CarouselControls'
import CarouselIndicators from './CarouselIndicators'
import './Carousel.scss'

class Carousel extends Component {
  state = {
    activeIndex: 0,
  }

  next = () => {
    this.reactSwipe.next()
  }

  prev = () => {
    this.reactSwipe.prev()
  }

  goToIndex = index => {
    this.reactSwipe.slide(index, this.props.swipeOptions.speed)
  }

  ////This callback function gets called on any slide change
  updateIndex = () => {
    this.setState({ activeIndex: this.reactSwipe.getPos() })
  }

  render() {
    const {
      slides,
      carouselControls,
      carouselControlsType,
      swipeOptions,
      className,
      carouselIndicatorsClassName,
    } = this.props
    const options = { ...swipeOptions, callback: this.updateIndex }
    return (
      <section className={`classic-carousel ${carouselIndicatorsClassName} ${className}`}>
        <div className="carousel_wrap">
          {carouselControls && carouselControlsType === 'triangle' && (
            <CarouselControls
              next={this.next}
              prev={this.prev}
              type={carouselControlsType}
              currentSlide={this.state.activeIndex}
              totalSlides={slides.length}
            />
          )}
          <ReactSwipe
            ref={reactSwipe => (this.reactSwipe = reactSwipe)}
            key={slides.length}
            className="carousel"
            swipeOptions={options}
          >
            {slides}
          </ReactSwipe>
          {/*Controls will default to below the carousel unless the props indicates to put on top*/}
          {carouselControls && carouselControlsType !== 'triangle' && (
            <CarouselControls
              next={this.next}
              prev={this.prev}
              type={carouselControlsType}
              currentSlide={this.state.activeIndex}
              totalSlides={slides.length}
            />
          )}
          {this.props.carouselIndicators && (
            <CarouselIndicators
              className={carouselIndicatorsClassName}
              currentSlide={this.state.activeIndex}
              totalSlides={slides}
              goToIndex={this.goToIndex}
            />
          )}
        </div>
      </section>
    )
  }
}

export default Carousel
